import { BaseApi } from './base.api.js';

export class PartyTemplateApi extends BaseApi {
    constructor(client) {
        super(client, '/party-templates');
    }

    async resolve(params) {
        return this.client.get(`${this.basePath}/resolve`, { params });
    }

    async cloneToTenant(id) {
        const response = await this.client.post(`${this.basePath}/${id}/clone`, {});
        return response.data;
    }

    async publishNewVersion(id, payload) {
        return this.client.post(`${this.basePath}/${id}/publish`, payload || {});
    }
}
